export const style = {
  container: {
    padding: "1.2rem 0.8rem",
    borderBottom: "0.1rem solid var(--gray-20)",
    cursor: "pointer",
  },
  active: { backgroundColor: "var(--peach-300)" },
  name: {
    display: "flex",
    alignItems: "center",
    color: "var(--gray-700)",
    fontSize: "1.4rem",
    fontWeight: 500,
  },
};
